import { platformsTitleNames, routesNames } from 'Consts/routeNames'

export const getRouteName = (path: string): string => {
  return (routesNames[path] || '') as string
}

export const getPlatformTitleName = (path: string): string | undefined => {
  const platform = path.split('/')[0]

  return platformsTitleNames[platform] ?? undefined
}

export const paramsStringFromObject = (params: { [key: string]: string }) => {
  if (params) {
    return `?${Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join('&')}`
  } else {
    return ''
  }
}

export const routeExist = (route: string) => route in routesNames

export const getUrlParam = (param: string): string | null => {
  const params = new URLSearchParams(window.location.search)
  return params.get(param)
}

const removeUrlPrefix = (url: string) => {
  const prefixes = ['https://', 'http://', 'ftp://', 'ftps://', 'sftp://']
  const matchingPrefix = prefixes.find((prefix) => url.startsWith(prefix))

  return matchingPrefix ? url.slice(matchingPrefix.length) : url
}

export const trimPrototcolAndWww = (url: string) => {
  return removeUrlPrefix(url)
    .trim()
    .replace(/^www\./, '')
    .replace(/\/+$/, '')
}
